<button *isavMapControl="'top right'" (click)="clear()" type="button" aria-label="Clear area">
    <span class="icon isav-map-icon">
        <i class="fas fa-trash" aria-hidden="true"></i>
    </span>
</button>
